import React, { useState, useContext, useEffect } from 'react'
import classNames from 'classnames'
import { FormattedMessage } from '~/translations/utils'
import Parser from 'html-react-parser'
import { formatDistance } from '~/utils/dateFns'
import { TicketContext } from '~/components/tickets/Show'
import Content from './answers/Content'
import Attachments from './answers/Attachments'
import { AnswerType } from '~/components/tickets/Show'

type ItemProps = {
  answer: AnswerType
}

const Answers: React.FC = ({}) => {
  const { ticket, clientAvatar, answers } = useContext(TicketContext)
  const { client, reportedBy } = ticket

  return (
    <>
      <div className="ticket-show-answers">
        {answers.map((item: AnswerType) => (
          <Item key={item.id} answer={item} />
        ))}
      </div>
    </>
  )
}

export default Answers

const Item: React.FC<ItemProps> = ({ answer }) => {
  const { ticket, clientAvatar } = useContext(TicketContext)
  const { client, reportedBy, octopusEmailFrom } = ticket

  const user = answer.user
    ? window.c.users.find(e => e.id == answer.user.id)
    : null
  const avatar = user && !answer.clientEmail ? user.avatar : clientAvatar
  const [emailFrom, setEmailFrom] = useState<string | null>(null)

  useEffect(() => {
    if (answer.emailFrom) {
      if (
        !client.contacts.some(contact => contact.value == answer.emailFrom) &&
        octopusEmailFrom != answer.emailFrom
      ) {
        setEmailFrom(answer.emailFrom)
      }
    }
  }, [])

  return (
    <div className="ticket-show-answers-item">
      <div className="ticket-show-answers-avatar">
        <img
          src={
            emailFrom
              ? '/img/cc.png'
              : avatar && !answer.userGuestEmail
              ? avatar
              : '/avatarsimg/limdesk.png'
          }
          alt="avatar"
        />
      </div>
      <div className="ticket-show-answers-main">
        <div className="ticket-show-answers-header">
          <div className="ticket-show-answers-client">
            {/* <a href="#">{answer.user.name}</a> */}
            {user ? (
              <a href={'/user/' + user.id}>{user.name} </a>
            ) : emailFrom ? (
              emailFrom
            ) : answer.userGuestEmail ? (
              answer.userGuestEmail
            ) : (
              <a href={'/client/' + client.id}>{client.name} </a>
            )}
            {client && answer.private && (
              <span className="tag ticket-show-answers-tag">
                <FormattedMessage id="ticket / answers / item / private" />
              </span>
            )}

            {!user && !answer.userGuestEmail && (
              <span
                className={classNames(
                  'ticket-show-answers__badge ticket-answers__badge--primary',
                  {
                    'ticket-show-answers__badge--secondary': emailFrom,
                  }
                )}
              >
                <span className="tag ticket-show-answers-tag ticket-show-answers-tag--client">
                  {emailFrom ? 'CC' : 'Klient'}
                </span>
              </span>
            )}
          </div>
          <div className="ticket-show-answers-date">
            {formatDistance(new Date(answer.added.date))}
          </div>
        </div>
        <div
          className={classNames('ticket-show-answers-content', {
            'ticket-show-answers-content--note': answer.private && client,
          })}
        >
          <Content item={answer} />

          {answer.newState == 0 &&
            Parser(intl.formatMessage({ id: 'ticket / new state / reopen' }))}
          {answer.newState == 1 &&
            Parser(intl.formatMessage({ id: 'ticket / new state / solved' }))}
          {answer.newState == 2 &&
            Parser(intl.formatMessage({ id: 'ticket / new state / rejected' }))}
          {answer.newState == 3 &&
            Parser(
              intl.formatMessage({ id: 'ticket / new state / removed client' })
            )}

          {answer.attachments && (
            <Attachments attachments={answer.attachments} />
          )}

          {answer.cc.filter(c => c.email != emailFrom).length ? (
            <div className="ticket-show-answers__delegated">
              cc:
              {answer.cc.map((cc, index) => {
                const last = answer.cc.length - 1 == index
                return (
                  cc.email != emailFrom && (
                    <span className="p-0" key={index}>
                      {' '}
                      {cc.email}
                      {!last && ','}
                    </span>
                  )
                )
              })}
            </div>
          ) : null}

          {answer.delegated && (
            <div className="ticket-show-answers__delegated">
              <span className="fas fa-share"></span>
              {answer.seconded.length == 1 ? (
                <FormattedMessage id="ticket / answers / item / delegate / singular" />
              ) : (
                <FormattedMessage id="ticket / answers / item / delegate / plural" />
              )}
              {answer.seconded.map((id, index) => {
                const delegatedUser = window.c.users.find(e => e.id == id)
                const last = answer.seconded.length - 1 == index

                return (
                  <span className="p-0" key={id}>
                    {' '}
                    <a href={'/user/' + delegatedUser?.id}>
                      {delegatedUser?.name}
                    </a>
                    {!last && ','}
                  </span>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
